import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_3"
    width="100%"
    height="100%"
    x={0}
    y={0}
    style={{
      enableBackground: "new 0 0 130 110",
    }}
    viewBox="6.99 9.2 119.82 84.8"
    {...props}
  >
    <style>
      {`.st0,.st1{fill:none;stroke:${strokeColor};stroke-miterlimit:10}.st1{fill:${strokeColor}}`}
    </style>
    <path
      d="M67.2 9.7s-11.6.2-19.8.7-10 .6-12.1 3.2c-2.1 2.7-9.7 18.5-9 22.5"
      className="st0"
    />
    <path
      d="M38.8 11.4s-4.2-.7-7.2 3.4c-2.9 4.1-8.2 16.5-8.9 18.9-.7 2.4-4.3 6.2-6 6.9M67.2 9.7s11 .2 19.2.7 10 .6 12.1 3.2c2.1 2.7 9.7 18.1 9 22.2"
      className="st0"
    />
    <path
      d="M95 11.4s4.2-.7 7.2 3.4c2.9 4.1 8.2 16.5 8.9 18.9.7 2.4 4.2 6.4 5.9 7.1M110.3 35.9s-57.4-.9-87.3.5c0 0-3.5 4.7-2.9 6.9.5 2.2 3 12.4 7.2 12.4s31.7.6 44.2.7c12.5.1 29.6-1.5 35.1-2.1 5.6-.5 6.9-9.1 7.1-11.7.1-2.6-3.4-6.7-3.4-6.7z"
      className="st0"
    />
    <path
      d="M33.5 16.7s9.5-.6 28.5-1.2 38.3 1.2 38.3 1.2M27.2 86.5s.1 3.7 0 5.3c-.1 1.7-2.2 1.5-2.2 1.5h-8.2c-2.3 0-2.2-2-2.2-2s.2-19.9.1-24.2c-.1-4.3 0-16.8 0-16.8v-.6"
      className="st0"
    />
    <path
      d="M14.7 59.4c.7 5.1 1.4 10.9 2 16 .4 2.4.1 5.5 2.3 7 2.4 1 5.2.1 7.7 0 3.5-.5 7.1-.8 10.6-1.7-3.4 1.3-7 1.8-10.5 2.4-3.3.4-8.7 2.1-10.1-2.2-1-3.6-1-7.1-1.3-10.8-.4-3.5-.6-7.1-.7-10.7z"
      className="st1"
    />
    <path
      d="M16.8 40.3c0 .1-2.4 4.6-2.2 9.7M17.3 40.8l-2.9-2.9M19.4 32.4s.3 4.6-.6 4.9c-.9.2-4.1.2-4.9.9-.8.7-2.7.8-3.9.4-1.2-.3-3.3-2-2.2-4.3 1-2.2 4.4-3.2 7.9-3.6 3.5-.3 3.7.8 3.7 1.7zM7.7 36.5h11.6M19.4 36.3c1.2-2.1 3.5-3.1 3.5-3.1M119.1 50.5s.1 12.4 0 16.8c-.1 4.3.1 24.2.1 24.2s.1 2-2.2 2h-8.2s-2.1.1-2.2-1.5c-.1-1.7 0-5.3 0-5.3"
      className="st0"
    />
    <path
      d="M119.1 59.6c-.1 3.6-.3 7.2-.6 10.8-.4 3.7-.3 7.2-1.3 10.8-1.4 4.3-6.8 2.6-10.1 2.2-3.5-.6-7.1-1.1-10.5-2.4 3.5.9 7.1 1.2 10.6 1.7 2.5.1 5.3 1 7.7 0 2.2-1.4 1.8-4.6 2.3-7 .6-5.2 1.2-10.9 1.9-16.1z"
      className="st1"
    />
    <path
      d="M117 40.8c.3.1 3.4 4.1 2.2 9.5v.4M116.5 41l2.9-2.9M114.4 32.6s-.4 4.6.6 4.9c.9.2 4.1.2 4.9.9s2.7.8 3.9.4c1.2-.3 3.3-2 2.2-4.3-1-2.2-4.4-3.2-7.9-3.6-3.5-.3-3.7.8-3.7 1.7zM126.1 36.7h-11.6"
      className="st0"
    />
    <path
      d="M114.4 36.5c-1.2-2.1-3.5-3.1-3.5-3.1M21.8 83.4s1.7 3.2 2.7 3.3c1 .1 5.8.2 6.2-.4.5-.5.6-1.1 1.8-1.2 1.2-.1 19.3.1 20.8 0s.7.7 2.5.7 6.4-.1 7.4-.2 1-.8 1.8-.8h4"
      className="st0"
    />
    <path
      d="M112.3 83.4s-1.7 3.2-2.7 3.3c-1 .1-5.8.2-6.2-.4-.5-.5-.6-1.1-1.8-1.2-1.2-.1-19.3.1-20.8 0s-.7.7-2.5.7-6.4-.1-7.4-.2-1-.8-1.8-.8H65"
      className="st0"
    />
  </svg>
);
export default SvgComponent;
